import { formatWorkflowSource } from "context/workflowReference";

// A record carrying `definition` names its own; one from before the snapshot epic is looked up in this
// revision's definitions by its `definition_id`. `pending` marks a lookup not yet answered, not a miss.
export function definitionLabel(execution, definitionsIndex) {
  const resolved = execution && execution["definition"];
  if ( resolved ) {
    const foreign = resolved["revision_id"] !== execution["revision_id"];
    return {
      alias: resolved["alias"] || null,
      source: foreign ? formatWorkflowSource(execution["workflow"]) : null,
      pending: false
    };
  }
  if ( !definitionsIndex ) {
    return { alias: null, source: null, pending: true };
  }
  const known = execution ? definitionsIndex[execution["definition_id"]] : null;
  return { alias: known ? known["alias"] : null, source: null, pending: false };
}
